import { jsx as _jsx } from "react/jsx-runtime";
import './FormGridLine.css';
/**
 * Creates a line in a form grid, starting at the given layout, that does not follow the grid layout.
 * Uses horizontal flex layout.
 */
const FormGridLine = (({ children, className, start, span = 1, align = 'left' }) => {
    return _jsx("div", { className: `formGridLine ${align} ${className || ''}`, style: start ? { gridColumn: `${start.toString()}${span ? ` / span ${span}` : ''}` } : {}, children: children });
});
export default FormGridLine;
